import React, { useState, useEffect } from 'react';

import { withRouter } from "react-router-dom";
import PageWrapper from '../PageWrapper'
import { API_BASE_URL } from '../../config';
import { connect } from 'react-redux'

import 'react-toastify/dist/ReactToastify.css';

//import Successalert from '../SuccessMessage'
function ContactUs(props) {

    useEffect(() => {
        window.scrollTo({ top: 0 });
    }, [])
    const [state, setState] = useState({
        email: "",
        name: props.loginData ? props.loginData.user_fname : '',
        message: "",
        error: { name: '', message: '' }, loader: false, success: false, checked: false, successeres: ''
    })
    const handleChange = (e) => {
        setState(prevState => ({
            ...prevState,
            error: { name: '', message: '' }, successeres: ''
        }))
        const { name, value } = e.target
        setState(prevState => ({
            ...prevState,
            [name]: value
        }))

    }
    const handleSubmitClick = async (e) => {
        e.preventDefault();
        if (state.name === "") {
            setState(prevState => ({
                ...prevState,
                error: { name: 'name', message: "Please enter your name" }
            }))
        } else {
            if (/^[a-z0-9][a-z0-9-_\.]+@([a-z]|[a-z0-9]?[a-z0-9-]+[a-z0-9])\.[a-z0-9]{2,10}(?:\.[a-z]{2,10})?$/.test(state.email)) {
                if (state.message !== "") {
                    await setState((prev) => ({
                        ...prev, loader: true, successeres: ''
                    }))

                    var data = new FormData();
                    data.append("action", "contact_us")
                    data.append("contact_us_name", state.name)
                    data.append("contact_us_email", state.email)
                    data.append("contact_us_message", state.message)

                    const requestOptions = {
                        method: 'post',
                        body: data
                    };

                    fetch(API_BASE_URL + 'data_process.php', requestOptions)
                        .then((response) => response.json())
                        .then(async (responseJson) => {

                            setState((prev) => ({
                                ...prev, loader: false, successeres: '',   email: "",
                                name: props.loginData ? props.loginData.user_fname : '',
                                message: "",
                            }))
                        })
                        .catch((error) => {

                        });
                } else {
                    setState(prevState => ({
                        ...prevState,
                        error: { name: 'message', message: "Please enter your message" }
                    }))

                }
            } else {
                setState(prevState => ({
                    ...prevState,
                    error: { name: 'email', message: "Please enter valid email" }
                }))

            }
        }
    }

    return (
        <PageWrapper title={"contact"} isLogin={false}>

            {/* { <div class="inner_pages">

                <div class="container">
                    <div class="mdc-title">
                        <h2>Contact Us</h2>
                    </div>

                </div>
                <div className="container">
                    <div className="row">
                        <div className="col-12 col-md-6">
                            <div class="form_wrapper" style={{ width: "100%", height: 'auto' }}>
                                <div class="form_container">


                                    <form>

                                        <div class="input_field">
                                            <label class="txt_title">Name*</label>
                                            <input type="text" name="name" placeholder="Name" value={state.name}
                                                onChange={handleChange} />
                                            {<p className={"errormessage"}>{state.error.name === "name" && state.error.message}</p>}
                                        </div>
                                        <div class="input_field">
                                            <label class="txt_title">Email*</label>
                                            <input type="email" name="email" placeholder="Email" value={state.email}
                                                onChange={handleChange} />
                                            {<p className={"errormessage"}>{state.error.name === "email" && state.error.message}</p>}
                                        </div>

                                        <div class="input_field">
                                            <label class="txt_title">Message*</label>
                                            <textarea type="text" name="message" placeholder="Message" style={{ "min-height": "105px" }} value={state.message}
                                                onChange={handleChange} />
                                            {<p className={"errormessage"}>{state.error.name === "message" && state.error.message}</p>}
                                        </div>



                                        <div class="input_btn">
                                            <input class="button" type="submit" value="Send" onClick={handleSubmitClick} disabled={state.loader} style={{ opacity: state.loader ? 0.5 : 1 }} />
                                        </div>

                                    </form>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-md-6">
                            <div style={{ "width": '100%', "margin-top": " 30px", "margin-bottom": "30px", "height": "100%" }}>
                                <img src={require("../../images/contact.png")} alt={"Contact"} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>} */}
            <div className="inner_pages_box w-left">
                <div className="contact_us inner_pages mb">
                    <div className="container">
                        <div className="mdc-title">
                            <h3>Contact Us<span>Contact Us</span></h3>
                        </div>
                    </div>
                    <div className="container">
                        <div className="row">
                            <div className="contactLeftBox">
                                <div className="form_wrapper width_100">
                                    <div className="form_container">
                                        <form>
                                            <div className="input_field">
                                                <label className="txt_title">Name*</label>
                                                <input type="text" name="name" placeholder="Name" value={state.name}
                                                    onChange={handleChange} />
                                                {<p className={"errormessage"}>{state.error.name === "name" && state.error.message}</p>}
                                            </div>
                                            <div className="input_field">
                                                <label className="txt_title">Email*</label>
                                                <input type="email" name="email" placeholder="Email" value={state.email}
                                                    onChange={handleChange} />
                                                {<p className={"errormessage"}>{state.error.name === "email" && state.error.message}</p>}
                                            </div>
                                            <div className="input_field">
                                                <label className="txt_title">Message*</label>
                                                <textarea type="text" name="message" placeholder="Message" style={{ "min-height": "105px" }} value={state.message}
                                                    onChange={handleChange} />
                                                {<p className={"errormessage"}>{state.error.name === "message" && state.error.message}</p>}
                                            </div>
                                            <div className="siteBtn_box textLeft">
                                            <input class="button" type="submit" value="Send" onClick={handleSubmitClick} disabled={state.loader} style={{ opacity: state.loader ? 0.5 : 1 }} />
                                                </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                            <div className="contactRightBox">
                                <div className="contact_right">
                                    <img src={require("../../images/contact_us.png")} alt="Contact" />
                                </div>
                                {/*  <div class="mapContact">
                      <iframe src="https://www.google.com/maps/embed?pb=!1m16!1m12!1m3!1d2965.0824050173574!2d-93.63905729999999!3d41.998507000000004!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!2m1!1sWebFilings%2C+University+Boulevard%2C+Ames%2C+IA!5e0!3m2!1sen!2sus!4v1390839289319" width="100%" height="300" frameborder="0" style="border:0"></iframe>
                  </div> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </PageWrapper>
    )
}
const mapStateToProps = (state) => {

    return {
        loginData: state.list.login
    };
};
const mapDispatchToProps = (dispatch) => {
    return {

        login: (data) => dispatch({ type: "LOGIN_INFO", payload: data })
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ContactUs));
//export default withRouter(LoginForm);